// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__MZ67h","title--center":"Title_title--center__qJgNX","title--white":"Title_title--white__aQza_"};